<template>
  <div>
    <nd-dialog v-model="turntablePopup" class="dialog" :footer="false">
      <div class="turntable-popup-content" slot="custom">
        <img
          ref="turntable"
          class="turntable end"
          src="../images/img_c.png"
        />
        <img class="turntable front" src="../images/img_d.png" />
      </div>
    </nd-dialog>
    <nd-dialog v-model="redPacketPopup" class="dialog" :footer="false">
      <div class="red-packet-popup-content" slot="custom">
        <div class="red-packet__top" ref="redPacket">
          <img class="light" src="../images/img_2.png" />
          <img class="packet" src="../images/img_1.png" />
          <div class="result">
            <p>恭喜您获得免息红包</p>
            <p>
              <span class="DIN">{{ day }}</span>天
            </p>
          </div>
          <div class="close" @click="clickCloseHandler"></div>
        </div>
        <img class="red-packet__bottom" src="../images/img_0.png" />
      </div>
    </nd-dialog>
  </div>
</template>
<script>
import 'web-animations-js/web-animations.min.js'

const n = 5

function genAngRange (day) {
  switch (day) {
    case 3:
      return [5, 55]
    case 30:
      return [65, 115]
    case 15:
      return [125, 175]
    case 10:
      return [185, 235]
    case 7:
      return [245, 295]
    case 5:
      return [305, 355]
    default:
      return [5, 55]
  }
}
function genRandomAng (min, max) {
  const range = max - min
  const rand = Math.random()
  return min + Math.floor(rand * range) + 360 * n
}

export default {
  data () {
    return {
      turntablePopup: false,
      redPacketPopup: false
    }
  },
  props: {
    day: Number
  },
  computed: {
    deg () {
      const [min, max] = genAngRange(this.day)
      return genRandomAng(min, max)
    }

  },
  watch: {
    turntablePopup (val) {
      if (val) {
        this.$nextTick(this.lottery)
      }
    }
  },
  methods: {
    open () {
      this.turntablePopup = true
    },
    clickCloseHandler () {
      this.$emit('clickClose')
      this.$emit('animationEnd')
      this.redPacketPopup = false
    },
    lottery () {
      if (!this.$refs.turntable) return
      const animation = this.$refs.turntable.animate(
        [
          { transform: `translate3d(-50%, 0, 0) rotate(0deg)` },
          {
            transform: `translate3d(-50%, 0, 0) rotate(${this.deg}deg)`
          }
        ],
        {
          fill: 'forwards',
          duration: (this.deg / 360) * 1000,
          easing: 'ease'
        }
      )
      animation.onfinish = () => {
        setTimeout(() => {
          this.redPacketPopup = true
          this.turntablePopup = false
          this.$refs.redPacket.addEventListener('animationend', () => {
            this.redPacketPopup = false
            this.$emit('animationEnd')
          })
        }, 1000)
      }
    }
  }
    
}
</script>
<style lang="less" scoped>
@import "../../../../assets/less/mixin.less";

@keyframes rotate {
    from {
        transform: translate3d(-50%, 0, 0) rotate(0deg);
    }
    to {
        transform: translate3d(-50%, 0, 0) rotate(360deg);
    }
}
@keyframes receive {
    from {
        transform: translate3d(0, 0, 0) scale(1);
    }
    to {
        transform: translate3d(0, 637px, 0) scale(0.1);
        opacity: 0;
    }
}
.turntable-popup-content {
    position: relative;
    width: 722px;
    height: 759px;
    margin: auto;
    .end {
        position: absolute;
        top: 0;
        left: 50%;
        width: 654px;
        height: 654px;
        transform: translate3d(-50%, 0, 0) rotate(0deg);
    }
    .front {
        position: absolute;
        top: 0;
        bottom: 0;
    }
}
.red-packet {
    &__top {
        position: relative;
        transform-origin: center center;
        animation: receive 2s forwards 2s;
        .light {
            position: absolute;
            top: 0;
            left: 50%;
            transform: translate3d(-50%, 0, 0);
            animation: rotate 1s linear infinite;
            width: 602px;
            height: 490px;
            z-index: 1;
        }
        .packet {
            position: relative;
            width: 459px;
            height: 599px;
            margin: auto;
            z-index: 2;
        }
        .result {
            position: absolute;
            width: 100%;
            top: 400px;
            left: 50%;
            transform: translateX(-50%);
            text-align: center;
            z-index: 3;
            font-size: 30px;
            line-height: 50px;
            color: #fff;

            .DIN {
                font-size: 70px;
                font-family: DIN-Medium;
                font-weight: 500;
                color: rgba(255, 219, 75, 1);
            }
        }
        .close {
            position: absolute;
            top: 0;
            right: 0;
            width: 60px;
            height: 60px;
            z-index: 4;
        }
    }

    &__bottom {
        position: relative;
        margin: 287px auto 0;
        width: 146px;
        height: 152px;
    }
}
</style>
